<template lang="pug">
div.container-fluid.animated.fadeIn
  nav(aria-label="breadcrumb")
    b-breadcrumb
      b-breadcrumb-item
        router-link(to="/report/depositedMemberCNY")
          i.fa.fa-poll-h
          span.ml-1 {{ $t("ui.deposited_member_cny") }}
  div.row
    div.col-md-12
      div.card
        div.card-header
          div.row
            div.col-md-12.mb-1
              div.row.mb-1
                div.col-md-3.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      i.icon-user
                    DebounceInput(required autofocus type="text" v-model="search" :placeholder="$t('message.search_by_id')" @enter="getReportList(true)")
                div.col-md-9
                  div.row.col-md-12
                    div(width="10%")
                      SubmitButton(
                        :loading="loading"
                        icon="fa fa-search"
                        :text="$t('ui.search')"
                        type="button"
                        @click="getReportList(true)"
                        variant="success"
                        size="sm"
                        ).mr-2
                      jsonToExcel(v-if="reportList.length > 0" mode="DepositedMemberCNY" tbl="tblList" :date="dateRange")
        div.card-body
          div.mb-1
            div.row.mb-1
              div.col-md-10
                b-pagination.float-left(
                  size="sm"
                  hide-ellipsis
                  :total-rows="totalRow"
                  :per-page="getPageSize"
                  v-model="currentPage"
                  @input="changedPage($event)").mb-1
              div.col-md-2
                b-input-group(:prepend="$t('ui.page_size')" size="sm").mb-1
                  b-form-select(:options="$store.getters.utmPageSizeOptions" :value="getPageSize" @input="changedPageSize")
          div.row.clusterize
            div.col-md-12
              .clusterize-scroll
                table.tablex#tblList(style="width: 70%;")
                  thead
                    tr
                      th.sticky-position(width="10%")
                        span #
                      th.sticky-position.sortable(width="20%" @click="sortOrder('account_id')")
                        span(:title="$t('ui.account_id')") {{ $t('ui.account_id') }}
                        i(:class="changeSortKey('account_id')")
                      th.sticky-position.sortable(width="30%" @click="sortOrder('deposit_amount')")
                        span(:title="$t('ui.deposit_amount')") {{ $t('ui.deposit_amount') }}
                        i(:class="changeSortKey('deposit_amount')")
                      th.sticky-position.sortable(width="20%" @click="sortOrder('deposit_count')")
                        span(:title="$t('ui.deposit_count')") {{ $t('ui.deposit_count') }}
                        i(:class="changeSortKey('deposit_count')")
                      th.sticky-position.sortable.text-right(width="20%" @click="sortOrder('modified_date')")
                        span(:title="$t('ui.modified_date')") {{ $t('ui.modified_date') }}
                        i(:class="changeSortKey('modified_date')")
                      th.sticky-position.sortable.text-right(width="20%" @click="sortOrder('created_date')")
                        span(:title="$t('ui.created_date')") {{ $t('ui.created_date') }}
                        i(:class="changeSortKey('created_date')")
                  tbody.clusterize-content
                    tr(v-if="reportList.length == 0")
                      td(:colspan="6").text-center
                        span {{ $t('message.no_data_available') }}
                    tr(v-for="(item, index) in reportList")
                      td
                        span(:title="((currentPage - 1) * getPageSize + index + 1)") {{ ((currentPage - 1) * getPageSize + index + 1) }}
                      td
                        span(:title="item.account_id") {{ item.account_id }}&nbsp;
                      td
                        span.font-weight-bold(:class="$helpers.fontClassName(item.deposit_amount)" :title="$n(item.deposit_amount, 'currency')") {{ $n(item.deposit_amount, 'currency') }}
                      td
                        span.font-weight-bold(:class="$helpers.fontClassName(item.deposit_count)" :title="$n(item.deposit_count, 'integer')") {{ $n(item.deposit_count, 'integer') }}
                      td.text-right
                        span(:title="$moment(item.modified_date).format('YYYY-MM-DD, HH:mm:ss')" v-if="item.modified_date") {{ $moment(item.modified_date).format('YYYY-MM-DD, HH:mm:ss') }}
                      td.text-right
                        span(:title="$moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss')" v-if="item.created_date") {{ $moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss') }}

</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import DateRangePicker from "@/library/DateRangePicker.vue";
import 'vue2-daterange-picker/dist/lib/vue-daterange-picker.min.css';
import jsonToExcel from "@/library/jsonToExcel.vue";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    DateRangePicker,
    jsonToExcel
  },
  data: () => ({
    loading: false,
    reportList: [],
    currentPage: 1,
    totalRow: 0,
    search: "",
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    sortKey: "created_date",
    sortType: "desc",
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.utmPageSize;
    },
    on() {
      return this.$t("ui.on");
    },
    off() {
      return this.$t("ui.off");
    }
  },
  mounted: function() {
    this.getReportList(true);
  },
  methods: {
    sortOrder(key) {
      if (this.sortKey == key)
        this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey = key;
        this.sortType = 'asc';
      }
      this.getReportList(true);
    },
    changeSortKey(key) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    getReportList: function(isSearch) {
      let url = config.memberDepositCNY2024Url();

      if (isSearch) this.currentPage = 1;

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId,
        sort_type: this.sortType,
        sort_key: this.sortKey,
        page_number: this.currentPage,
        page_size: this.getPageSize
      };

      if (this.search.trim() != '') {
        json.member_id = this.search.trim();
      }

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.reportList = response.data.dt;
                this.totalRow = this.reportList.length > 0 ? this.reportList[0].totalrows : 0;
              } else {
                this.totalRow = 0;
                this.reportList = [];
                if (this.feedback.status != 'permission_denied') {
                  if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
                }
                else {
                  this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
                }
                // if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setUTMPageSize", pageSize);
      this.currentPage = 1;
      this.getReportList(true);
    },
    changedPage: function(pageNo) {
      this.currentPage = pageNo;
      this.getReportList();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>
<style lang="scss" scoped>
.text-italic {
  font-style: italic !important;
}
</style>